import { useNavigate } from "react-router-dom";
import { pageText } from "../../utils/pageText";

const LinkStyle = {
  color: "blue",
  textDecoration: "underline",
  cursor: "pointer",
};

function EmptyDataset() {
  const navigate = useNavigate();

  return (
    <div className="empty-dataset">
      <h6>{pageText("This dataset is empty")}</h6>
      <p>{pageText("To load data, please:")}</p>
      <p>
        {pageText("Go to")}{" "}
        <a
          onClick={() => {
            navigate("/acquisition");
          }}
          style={LinkStyle}
        >
          <strong>{pageText("Acquisition-Data")}</strong>
        </a>
        .
      </p>
    </div>
  );
}

export default EmptyDataset;
